import React from 'react';
import PropTypes from 'prop-types';
import Logo from '~/assets/images/logo_puro.png';

import { Wrapper, Header } from './styles';

export default function AuthLayout({ children }) {
  return (
    <Wrapper>
      <Header>
        <h4>Bem-vindo ao LeadFlow</h4>
        <p>Seja muito bem-vindo ao LeadFlow</p>
        <div>
          <img src={Logo} alt="" />
        </div>
      </Header>
      {children}
    </Wrapper>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
